import { InvoiceDetail } from "@/model/entities/invoice-detail";
import { InvoiceHeader } from "@/model/entities/invoice-header";
import { DomainBaseComponent } from "@/shared/domain-base.component";
import { DomainService } from "@/shared/domain.service";
import { UtilFns } from "@/shared/util-fns";
import {
  Component,
  ElementRef,
  OnDestroy,
  ViewChild,
  ViewEncapsulation,
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { firstValueFrom, takeUntil } from "rxjs";
import { PrintFns } from "@/shared/print-fns";
import { environment } from "environments/environment";
import { HttpClient } from "@angular/common/http";

@Component({
  selector: "app-printable-packing-slip",
  templateUrl: "./printable-packing-slip.component.html",
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class PrintablePackingSlipComponent
  extends DomainBaseComponent
  implements OnDestroy {
  @ViewChild("printableArea") printElementRef: ElementRef;

  invoiceId: string;
  invoice: InvoiceHeader;
  getAddress = UtilFns.getAddress;
  details: InvoiceDetail[] = [];
  recurl = "";
  qrurl = "";
  pdfurl = "";

  constructor(
    protected domainService: DomainService,
    protected route: ActivatedRoute,
    private http: HttpClient,
    private elementRef: ElementRef
  ) {
    super(domainService);

    this.route.paramMap.pipe(takeUntil(this.onDestroy)).subscribe(() => {
      this.updateFromContext();
    });
  }

  ngOnDestroy(): void { }

  async updateFromContext() {
    await this.dbQueryService.cacheAll();
    this.invoiceId = this.route.snapshot.params["invoiceId"];

    const url = environment.entitiesApiRoot + '/GetInvoiceReceivedUrl/' + this.invoiceId;
    this.recurl = await firstValueFrom(this.http.get(url, { responseType: 'text' }));
    const encoded = encodeURIComponent(this.recurl);
    this.qrurl = environment.entitiesApiRoot + '/GetUrlQrCodePng/' + encoded;

    this.invoice = await this.dbQueryService.getInvoice(this.invoiceId);
    if (this.invoice == null) {
      this.isPageReady = true;
      return;
    }
    this.details = this.invoice.invoiceDetails;

    this.isPageReady = true;

    setTimeout(() => {
      this.preparePrint();
      const mediaQueryList = window.matchMedia("print");
    }, 0);
  }

  printDocument() {
    const pwin = window.open(this.pdfurl, "_blank");
  }

  preparePrint() {
    this.pdfurl =
      environment.apiRoot +
      "api/pdf/pdffromurl/packingSlip" +
      this.invoice.id +
      "?url=" +
      UtilFns.getBaseUrl() +
      "printable-packing-slip/" +
      this.invoice.id +
      "&headerLeft=Packing Slip " +
      this.invoice.id;
    this.isPageReady = true;

    let el: HTMLElement =
      this.printElementRef && this.printElementRef.nativeElement;
    if (el == null) {
      el = this.elementRef && this.elementRef.nativeElement;
    }
    if (!el) {
      return;
    }
    PrintFns.printElement(el);
  }
}
